import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          background: "#0a0f1a", color: "#e2e8f0", fontFamily: "Inter, sans-serif",
          gap: 16, padding: 32, textAlign: "center"
        }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <h2 style={{ margin: 0, fontSize: "1.4rem", fontWeight: 700 }}>Something went wrong</h2>
          <p style={{ margin: 0, color: "#64748b", maxWidth: 400, fontSize: "0.9rem" }}>
            An unexpected error occurred. Try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8, padding: "10px 24px", borderRadius: 8, border: "none",
              background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
              color: "#fff", fontWeight: 600, cursor: "pointer", fontSize: "0.95rem"
            }}
          >
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
